import React from 'react';
import { Box, Typography, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useTranslation } from 'react-i18next';
import { helpSectionStyles } from '../styles';

export const HelpSection = () => {
  const { t } = useTranslation();
  
  const helpItems = [
    { key: 'invoices' },
    { key: 'quotes' },
    { key: 'products' },
    { key: 'delivery' }
  ];

  return (
    <Box sx={helpSectionStyles.container}>
      <Typography 
        variant="h3" 
        sx={helpSectionStyles.title}
      >
        {t('ecommerce.support.helpWith.title', 'Te ayudamos con:')}
      </Typography>
      <List>
        {helpItems.map((item) => (
          <ListItem key={item.key} sx={helpSectionStyles.listItem}>
            <ListItemIcon>
              <CheckCircleIcon sx={helpSectionStyles.checkIcon} />
            </ListItemIcon>
            <ListItemText 
              primary={t(`ecommerce.support.helpWith.${item.key}`, `Ver facturas anteriores`)}
              primaryTypographyProps={{ sx: helpSectionStyles.listText }}
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default HelpSection; 